import api from '../config/api';

export const authService = {
    /**
     * Login user
     * @param {string} email
     * @param {string} password
     * @returns {Promise}
     */
    login: async (email, password) => {
        const response = await api.post('/auth/login', { email, password });
        // Backend returns: { success: true, data: { user, token } }
        if (response.data.success && response.data.data?.token) {
            localStorage.setItem('auth_token', response.data.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.data.user));
            return {
                success: true,
                token: response.data.data.token,
                user: response.data.data.user
            };
        }
        throw new Error('Login failed: Invalid response');
    },

    /**
     * Register user
     * @param {Object} data
     * @returns {Promise}
     */
    register: async (data) => {
        const response = await api.post('/auth/register', data);
        // Backend returns: { success: true, data: { user } }
        if (response.data.success && response.data.data?.user) {
            // Registration might not return token immediately (phone verification required)
            if (response.data.data.token) {
                localStorage.setItem('auth_token', response.data.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.data.user));
            }
            return {
                success: true,
                token: response.data.data.token,
                user: response.data.data.user
            };
        }
        return response.data;
    },

    /**
     * Logout user
     */
    logout: () => {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
    },

    /**
     * Get current user
     * @returns {Object|null}
     */
    getCurrentUser: () => {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    },

    /**
     * Check if user is authenticated
     * @returns {boolean}
     */
    isAuthenticated: () => {
        return !!localStorage.getItem('auth_token');
    },

    /**
     * Get auth token
     * @returns {string|null}
     */
    getToken: () => {
        return localStorage.getItem('auth_token');
    },

    /**
     * Get user profile
     * @returns {Promise}
     */
    getProfile: async () => {
        const response = await api.get('/auth/me');
        return response.data;
    },

    /**
     * Update user profile
     * @param {Object} data
     * @returns {Promise}
     */
    updateProfile: async (data) => {
        const response = await api.put('/auth/profile', data);
        return response.data;
    },

    /**
     * Verify email
     * @param {string} email
     * @param {string} code
     * @returns {Promise}
     */
    verifyEmail: async (email, code) => {
        const response = await api.post('/auth/verify-email', { email, code });
        return response.data;
    },

    /**
     * Resend email verification code
     * @param {string} email
     * @returns {Promise}
     */
    resendEmailVerification: async (email) => {
        const response = await api.post('/auth/resend-email-verification', { email });
        return response.data;
    },
};

